import {
  CircularProgress,
  Heading,
  HStack,
  Text,
  VStack,
  List,
  ListItem,
  Icon,
} from "@chakra-ui/react";
import WidgetPanel from "../dashboard/WidgetPanel";
import { useContext } from "react";
import { FormContext } from "@/providers/form";
import { shouldDisplayField } from "./SelfServeSection";
import { flatMapFields } from "./CategoryProgress";
import { FaCircleCheck } from "react-icons/fa6";

export const isFieldComplete = (field: any, values: any) => {
  let fieldVal = values[field.databaseKey];

  if (field.parentDatabaseKey) {
    const parentFieldValue = values[field.parentDatabaseKey] || [];
    fieldVal = (parentFieldValue[field.childIndex] || {})[field.databaseKey];
  }

  if (field.parentFieldType === "GeneratedList") {
    const parentFieldValue = values[field.databaseKey] || {};
    fieldVal = parentFieldValue[field.label];
  }

  if (field.type === "ConditionsInput" && (fieldVal || []).length === 0) {
    return false;
  }
  if (field.type === "ListManager" && (fieldVal || []).length === 0) {
    return false;
  }
  if (field.type === "Template") {
    return values.templates[field.template] > 0;
  }

  if (
    fieldVal === null ||
    fieldVal === undefined ||
    fieldVal === "" ||
    Number.isNaN(fieldVal)
  ) {
    return false;
  }
  return true;
};

const CategoryStepper = () => {
  const { sections, values } = useContext(FormContext);

  return (
    <WidgetPanel>
      <List>
        {sections.map((section) => {
          const fields = section.fields
            .filter((field: any) => shouldDisplayField(field, values))
            .flatMap((field: any) => flatMapFields(field, values));
          const completed = fields.filter((field: any) =>
            isFieldComplete(field, values)
          ).length;

          const progress = Math.round((completed / fields.length) * 100);

          return (
            <ListItem
              key={section.title}
              mb="4"
              _last={{
                mb: 0,
              }}
            >
              <HStack gap="16px">
                {progress === 100 ? (
                  <Icon
                    as={FaCircleCheck}
                    color="brand.primary"
                    fontSize="28px"
                  />
                ) : (
                  <CircularProgress
                    value={progress}
                    color="brand.primary"
                    size="28px"
                  />
                )}

                <VStack alignItems="flex-start" gap="0px">
                  <Heading as="h3" fontSize="md" fontWeight="500" mb="0px">
                    {section.title}
                  </Heading>
                  <Text color="gray.600" fontSize="sm">
                    {completed}
                    {` out of `}
                    {fields.length} questions
                  </Text>
                </VStack>
              </HStack>
            </ListItem>
          );
        })}
      </List>
    </WidgetPanel>
  );
};

export default CategoryStepper;
